"use client";

import { useMemo } from "react";
import { z } from "zod/v4";

import {
  createContactPrefillSchema,
  writeContactPrefill,
} from "@/lib/webmcp/contact-prefill";
import { jsonToolResult } from "@/lib/webmcp/tool-result";
import { useWebMCPTool } from "@/lib/webmcp/use-webmcp-tool";

export function ContactPrefillTool({ fields }: { fields: unknown[] }) {
  const schema = useMemo(() => createContactPrefillSchema(fields), [fields]);
  const tool = useMemo(
    () => ({
      name: "prefill_contact_form",
      description:
        "Prefill allowed visible fields on the Wayflyer contact form. This never checks consent or submits the form.",
      inputSchema: z.toJSONSchema(schema),
      execute(input: Record<string, unknown>) {
        const prefill = schema.parse(input);
        writeContactPrefill(prefill);
        return jsonToolResult({
          prefilled: Object.keys(prefill).toSorted(),
          submitted: false,
        });
      },
    }),
    [schema]
  );

  useWebMCPTool(tool);
  return null;
}
